<template>
  <div class="wrapper">
    <v-sidebar activeNavItem="inventory"></v-sidebar>

    <div class="main-panel">
      <v-navbar
        v-bind:title="'Inventory'"
        v-bind:path="'/inventory'"
      ></v-navbar>

      <form @submit.prevent="beforeSubmit">
        <div class="content">
          <div class="container-fluid">
            <div class="row">
              <InventoryForm
                ref="form"
                v-bind:title="'Edit Inventory'"
              ></InventoryForm>
            </div>
            <div class="row">
              <div class="col-12 text-right">
                <p v-for="error in validationErrors" class="help is-danger">
                  {{ error.msg }}
                </p>

                <button
                  class="btn btn-simple btn-link btn-wd"
                  v-on:click="cancel()"
                >
                  <i class="fa fa-times"></i> Cancel
                </button>
                <button type="submit" class="btn btn-success btn-wd">
                  <i class="fa fa-save"></i> Save
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>

      <v-footer></v-footer>
    </div>
  </div>
</template>

<script>
import Vue from "vue";

import router from "../../router";
import apiService from "../../services/api.service";

import Sidebar from "../../components/Sidebar";
import Navbar from "../../components/Navbar";
import Footer from "../../components/AppFooter";
import InventoryForm from "./InventoryForm";

import { checkResponseErrors } from "../../utils/http";

export default {
  name: "InventoryEdit",
  components: {
    "v-sidebar": Sidebar,
    "v-navbar": Navbar,
    "v-footer": Footer,
    InventoryForm: InventoryForm,
  },
  data: () => ({
    loadData: null,
    validationErrors: [],
    type: null,
  }),
  async mounted() {
    this.id = this.$route.params.id;

    try {
      const resp = await apiService.get(
        "/inventory/get/" + this.$route.params.id
      );
      const body = resp.data;
      this.$refs.form.loadData(body.Result);
    } catch (error) {
      Vue.toasted.error(error.message, { duration: 3500 });
      this.cancel();
      return;
    }
  }, // end mounted
  methods: {
    cancel: () => router.push("/inventory/view"),
    addErrors: function (srcErrors) {
      if (srcErrors && srcErrors.count() > 0)
        this.validationErrors = this.validationErrors.concat(srcErrors.items);
    },
    beforeSubmit: async function () {
      this.validationErrors = [];
      this.serverError = null;

      const promises = this.$children.map((child) => {
        if (!child || !child.$validator) return;
        return child.$validator
          .validateAll()
          .then(() => this.addErrors(child.errors));
      });
      promises.push(this.$validator.validateAll());
      await Promise.all(promises);
      this.addErrors(this.errors);

      if (this.validationErrors.length) return;

      await this.submit();
    },
    submit: async function () {
      try {
        const inventory = this.$refs.form.getClearData();
        // inventory.id = this.$route.params.id;
        const response = await apiService.put(
          `/inventory/update/${this.$route.params.id}`,
          inventory
        );
        if (await checkResponseErrors(response)) return;
      } catch (error) {
        Vue.toasted.error(error.message || error, { duration: 3500 });
        return;
      }

      router.push("/inventory/view");
      Vue.toasted.success("Successfully Updated Inventory", { duration: 3500 });
    },
  },
};
</script>



// WEBPACK FOOTER //
// edit.vue?6193b196